const styles = {
  card: {
    display: 'flex',
    flexDirection: 'column',
  },
  video: (onlyVideo) => ({
    width: {
      xs: '252px',
      lg: '312px',
    },
    height: {
      xs: onlyVideo ? '432px' : '290px',
      lg: onlyVideo ? '534px' : '381px',
    },
    position: 'relative',
    borderRadius: 6,
    overflow: 'hidden',
    zIndex: 1,
  }),
  image: {
    width: '100%',
    aspectRatio: '1.42',
  },
  name: {
    my: 1,
    color: 'kit.text.main',
  },
  position: {
    marginTop: 'auto',
    color: 'kit.text.main',
  },
  companieLogo: {
    marginTop: '12px',
    height: {
      xs: '29px',
      xl: '25px',
    },
  },
  logoImage: {
    height: '100%',
    width: 'auto',
  },
  personalInfoBlock: (onlyVideo) => ({
    marginBottom: onlyVideo ? 0 : '16px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flexShrink: 0,
  }),
  personalInfo: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flexGrow: 1,
    mt: 2,
  },
  opinion: {
    width: '100%',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    fontSize: 14,

    marginBottom: '25px',
    paddingRight: '6px',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  links: {
    mt: 'auto',
    display: 'flex',
    alignItems: 'center',
  },
  socialLink: {
    display: 'flex',
    cursor: 'pointer',
    fontSize: 16,
  },
  social: {
    width: '24px',
    height: '24px',
    mr: 1,
    pointerEvents: 'none',
  },
};

export default styles;
